import { IApplicationState } from '../../types/redux';

export const selectSortingOptions = (state: IApplicationState) => {
  const { sortVariants } = state;

  return sortVariants.map(({ key, value }) => ({ label: value, value: key }));
};
